import { OrderByEnum, ProductType, restRepository } from "@onair/repositories";
import { UserRole } from "@onair/types";
import apiAxios from "../../academy/axios";

const ExtendedProductType = {
    ...ProductType,
    ONLINE: 'ONLINE',
    OFFLINE: 'OFFLINE',
} as const;

type ExtendedProductType = (typeof ExtendedProductType)[keyof typeof ExtendedProductType];

export interface AdminGetOrderItemsInput {
    cursor?: string;
    orderField?: string;
    order?: OrderByEnum;
    offset?: number;
    limit?: number;
    filter?: string;
    itemType?: ExtendedProductType;
    fromDate?: string;
    toDate?: string;
    userId?: string;
    hostId?: string;
    affiliateSource?: string;
    createdBy?: UserRole
}

export const getOrderItems = async (input: AdminGetOrderItemsInput) => {
    const res = await restRepository.api.adminGetAllOrderItem(input);
    return res.data;
};